import { Bell, Loader, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { can_visit, formatRelativeTime, getInitials, getPractice, notify } from "../../helpers";
import { getShortNotifications, markAsRead } from "../../services/notification";
import { Drawer } from 'vaul';

export default function NotificationDropdown({ profile, selectedPracticeChange, fetchChangePracticeData, haveNotification }) {

  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  let user_id = getPractice("user_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }

  const [userNotifications, setUserNotifications] = useState([]);
  const [loadNotification, setLoadNotification] = useState(true);
  const [readMarkLoader, setReadMarkLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const defaultFilter = {
    account_id: account_id,
    location_id: location_id,
    user_id: user_id,
    page: 1,
    per_page: 100
  };
  const [filter, setFilter] = useState(defaultFilter);
  const [drawerPosition, setDrawerPosition] = useState({ top: 0, right: 0 });

  const toggleDropdown = () => {
    const triggerElement = document.querySelector('.docpro_header_notification_icon');
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY,
        right: window.innerWidth - rect.right,
      });
    }
    setIsOpen(!isOpen);
  };

  const getNotifications = async (filterData) => {
    setFilter(filterData)
    try {
      if(can_visit('_notifications') && !can_visit('_role_trial')) {
        const response = await getShortNotifications(filterData);
        if(response){
          if (!response?.detail) {
            setUserNotifications(response?.data);
          }
        }
      }
    } catch (error) {
    } finally {
      setLoadNotification(false);
    }
  }

  const readAllanotifications = async () => {
    setReadMarkLoader(true);
    try {
      const readParams = {
        account_id: account_id,
        location_id: location_id,
        user_id: user_id
      }
      const result = await markAsRead(readParams);
      
      if(result){
        if(!result?.detail && result?.data?.status === 'success'){
          notify("success", result?.data?.message, 2);
          await getNotifications(filter);
        }
      }
    } catch (error) {} finally {
      setReadMarkLoader(false);
    }
  }

  const viewNotifications = () => {
    setIsOpen(false);
    navigate("/notification-logs");
  }

  useEffect(() => {
    setFilter({
      ...filter,
      location_id: location_id,
      account_id: account_id,
    });
    setLoadNotification(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, location_id]);

  return (
    <div style={{ position: "relative" }} ref={dropdownRef}>
      <Drawer.Root open={isOpen} onOpenChange={setIsOpen} >
        <Drawer.Trigger
          className="docpro_header_notification_icon"
          style={{ border: 'unset' }}
          onClick={() => {
            toggleDropdown();
            getNotifications(filter);
          }}
        >
          <Bell height={23} width={23} />
          {haveNotification && (
            <div className="docpro_have_notification"></div>
          )}
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay" />
          <Drawer.Content 
            className="docpro_drawer_content docpro_drawer_style_6"
            style={{ 
              top: drawerPosition.top,
              right: drawerPosition.right,
              position: 'absolute',
            }}
          >
            <Drawer.Title className="sr-only">Notifications</Drawer.Title>
            <Drawer.Description className="sr-only">Latest notification view</Drawer.Description>
            {!can_visit('_role_trial') && (
              <div className="docpro_dropdown notification_dropdown" >
                <div className="notification_dropdown_head">
                  <h5>Notifications</h5>
                  <span className="relative close_notification">
                    <span onClick={() => {setIsOpen(false)}} className="pointer">
                      <X height={20} width={20} />
                    </span>
                    {/* <span onClick={readAllanotifications} className="pointer">
                      <MailOpen height={20} width={20} />
                    </span>
                    {readMarkLoader && (
                      <span className="docpro_loading" style={{ background: '#dededec9', borderRadius: '6px' }}>
                        <Loader width={20} height={20} />
                      </span>
                    )} */}
                  </span>
                </div>

                <div className="notification_dropdown_list custom-scroll">
                  {!loadNotification ? (
                    userNotifications?.length > 0 ? (
                      
                      // <div key={index} className="notification_dropdown_list_item docpro_fw_400">
                      //   <div className="notification_message">
                      //     <strong>{notification?.created_by_name}</strong>
                      //     <span>{notification?.title}</span>
                      //   </div>
                      //   <Spacing lg="5" sm="5" />
                      //   <p>{formatRelativeTime(notification?.created_at)}</p>
                      // </div>
                      <ul className="notification_stepper" style={{ paddingLeft: '10px' }}>
                        {userNotifications?.map((notification, index) => (
                          <li key={index} className="notification_step no_step" style={{ marginBottom: '5px', paddingBottom: 0 }}>
                            <div className="docpro_message_item_avatar step_indicator">
                              {getInitials(`${notification?.created_by_name}`)}{" "}
                            </div>
                            <div className="step_content" style={{ marginLeft: 0 }}>
                              <p>
                                <strong>{notification?.created_by_name}</strong>
                                <span className="notification_time">{formatRelativeTime(notification?.created_at)}</span> <br />
                                <span className="heading_title">{notification?.title}</span>
                              </p>
                              {notification?.message != null && (
                                <p className="notification_comment limit" dangerouslySetInnerHTML={{ __html: notification?.message}}></p>
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="notification_dropdown_no_data text-center">
                        No notifications available
                      </div>
                    )
                  ) : (
                    <div className="notification_dropdown_no_data loading" >
                      <span className="docpro_loading" style={{ position: 'inherit' }}>
                        <Loader width={35} height={35} style={{ color: 'var(--accent)' }} />
                      </span>
                    </div>
                  )}
                </div>

                <div className="notification_dropdown_foot">
                  <div className="pointer" onClick={viewNotifications}>
                    See all notifications
                  </div>
                </div>
              </div>
            )}
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
